import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import ApiData from "../../../api/ApiData";
import { ReqItem } from "../../UI/ReqItem";
import { BtnPrimaryv4 } from "../../UI/button/BtnPrimaryv4";
import { CompanyClientLkRegisterModal } from "./CompanyClientLkRegisterModal";

export const CompanyClientLkStatusReqItem = observer(() => {
  const [registerOpen, setRegisterOpen] = useState(false);
  const companyId = ApiData.company.company?.id;
  const sameCompany = companyId && ApiData.clientLkUsersCompanyId === companyId;

  if (ApiData.clientLkUsersLoading && !sameCompany) {
    return (
      <ReqItem
        label="DMC ЛК клиента"
        value="…"
        muted
        className="manager-field"
      />
    );
  }

  if (ApiData.clientLkUsersForbidden || ApiData.clientLkUsersError) {
    return (
      <ReqItem
        label="DMC ЛК клиента"
        value="—"
        muted
        className="manager-field"
      />
    );
  }

  if (!sameCompany || ApiData.clientLkUsersPayload === null) {
    return (
      <ReqItem
        label="DMC ЛК клиента"
        value="—"
        muted
        className="manager-field"
      />
    );
  }

  const registered = !!ApiData.clientLkUsersPayload.registered_in_client_lk;
  const lastPassword = ApiData.clientLkLastDefaultPassword;

  return (
    <>
      <ReqItem
        className="manager-field"
        label="ЛК клиента DMC"
        value={
          registered ? (
            <span className="client-lk-status-block">
              <span className="client-lk-status-yes">Зарегистрирован</span>
              {lastPassword ? (
                <span className="client-lk-default-password company-card-v4-mono">
                  Пароль: {lastPassword}
                </span>
              ) : null}
            </span>
          ) : (
            <span className="client-lk-status-block">
              <span>Не зарегистрирован</span>
              <BtnPrimaryv4
                compact
                text="Зарегистрировать"
                onClick={() => setRegisterOpen(true)}
              />
            </span>
          )
        }
      />
      {registerOpen && companyId && !registered ? (
        <CompanyClientLkRegisterModal
          companyId={companyId}
          onClose={() => setRegisterOpen(false)}
        />
      ) : null}
    </>
  );
});
